import { lesion } from './lesion';
import { medias } from './../Global/medias.js';

class LesionAssessorSlides {
  constructor(app, report, evaluation, group, user) {
    this.app = app;
    this.report = report;
    this.evaluation = evaluation;
    this.group = group;
    this.user = user;
  }

  add(tableOfContentsCalculatorPosition) {
    let assessor = this.group.getAssessorByType('17');

    if (assessor === false || assessor.assessor.data === undefined) {
      throw (
        this.group.getName() + this.app.$t(' - ') + this.app.$t('Lesion assessor is not ready.')
      );
    }

    this.report.tableOfContentsHelper('Lesion', tableOfContentsCalculatorPosition, this.group);

    lesion(this.app, this.report, this.evaluation, this.group, assessor);
    medias(this.app, this.report, this.group, '17', this.user);
  }
}

export default LesionAssessorSlides;
